/**
 * ELEVEN — Shopify Theme JavaScript
 * Streetwear / Athleisure
 */

(function() {
  'use strict';

  /* =============================================
     UTILITY HELPERS
     ============================================= */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const on = (el, evt, fn, opts) => el && el.addEventListener(evt, fn, opts);
  const bodyLock = () => document.body.classList.add('no-scroll');
  const bodyUnlock = () => document.body.classList.remove('no-scroll');

  function formatMoney(cents) {
    const fmt = window.Eleven?.moneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    const amountNoDecimals = Math.round(cents / 100);
    const amountWithComma = amount.replace('.', ',');
    return fmt
      .replace('{{amount_with_comma_separator}}', amountWithComma)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals)
      .replace('{{amount}}', amount);
  }

  async function fetchJSON(url, options = {}) {
    const res = await fetch(url, {
      ...options,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', ...options.headers }
    });
    return res.json();
  }

  /* =============================================
     CART FUNCTIONS
     ============================================= */
  const Cart = {
    async get() {
      return fetchJSON('/cart.js');
    },

    // 24-oct-2026: acepta propiedades de línea (ej. properties[Regalo]) para que se vean en checkout y pedido
    async add(variantId, quantity = 1, properties) {
      const payload = properties ? { id: variantId, quantity, properties } : { id: variantId, quantity };
      const data = await fetchJSON('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify(payload)
      });
      await this.updateUI();
      this.openDrawer();
      return data;
    },

    async change(key, quantity) {
      const data = await fetchJSON('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify({ id: key, quantity })
      });
      await this.updateUI();
      await this.refreshDrawerContent();
      return data;
    },

    async updateUI() {
      const cart = await this.get();
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
      $$('[data-cart-drawer-count]').forEach(el => { el.textContent = `(${cart.item_count})`; });
      $$('[data-cart-drawer-subtotal], [data-cart-subtotal], [data-cart-total]').forEach(el => {
        el.textContent = formatMoney(cart.total_price);
      });
    },

    async refreshDrawerContent() {
      try {
        const response = await fetch(window.location.href);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('[data-cart-drawer]');
        const drawer = document.querySelector('[data-cart-drawer]');
        if (newDrawer && drawer) {
          const wasOpen = drawer.classList.contains('is-open');
          drawer.innerHTML = newDrawer.innerHTML;
          if (wasOpen) drawer.classList.add('is-open');
          initCartDrawerEvents();
          initTermsCheckbox();
        }
      } catch(e) {}
    },

    openDrawer() {
      const self = this;
      fetch(window.location.href)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newDrawer = doc.querySelector('[data-cart-drawer]');
          var drawer = document.querySelector('[data-cart-drawer]');
          var overlay = document.querySelector('[data-cart-overlay]');
          if (newDrawer && drawer) {
            drawer.innerHTML = newDrawer.innerHTML;
          }
          drawer.classList.add('is-open');
          overlay.classList.add('is-open');
          bodyLock();
          initCartDrawerEvents();
          initTermsCheckbox();
        });
    },

    closeDrawer() {
      const drawer = $('[data-cart-drawer]');
      const overlay = $('[data-cart-overlay]');
      if (drawer) { drawer.classList.remove('is-open'); }
      if (overlay) { overlay.classList.remove('is-open'); }
      bodyUnlock();
    }
  };

  /* =============================================
     CART DRAWER EVENTS
     ============================================= */
  function initCartDrawerEvents() {
    var closeBtn = document.querySelector('.cart-drawer__close');
    if (closeBtn) {
      closeBtn.onclick = function(e) {
        e.preventDefault();
        Cart.closeDrawer();
      };
    }

    document.querySelectorAll('[data-drawer-qty-minus]').forEach(function(btn) {
      btn.onclick = function() {
        var key = btn.getAttribute('data-drawer-qty-minus');
        var valueEl = btn.parentElement.querySelector('[data-drawer-qty-value]');
        var qty = parseInt(valueEl.textContent) - 1;
        Cart.change(key, Math.max(0, qty));
      };
    });

    document.querySelectorAll('[data-drawer-qty-plus]').forEach(function(btn) {
      btn.onclick = function() {
        var key = btn.getAttribute('data-drawer-qty-plus');
        var valueEl = btn.parentElement.querySelector('[data-drawer-qty-value]');
        var qty = parseInt(valueEl.textContent) + 1;
        Cart.change(key, qty);
      };
    });

    document.querySelectorAll('[data-drawer-remove]').forEach(function(btn) {
      btn.onclick = function() {
        Cart.change(btn.getAttribute('data-drawer-remove'), 0);
      };
    });
  }

  function initCartDrawer() {
    var cartBtn = document.querySelector('.header__cart-btn');
    if (cartBtn) {
      cartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        Cart.openDrawer();
      });
    }

    var overlay = document.querySelector('[data-cart-overlay]');
    if (overlay) {
      overlay.addEventListener('click', function() {
        Cart.closeDrawer();
      });
    }

    document.querySelectorAll('[data-quick-add]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = btn.getAttribute('data-quick-add');
        btn.disabled = true;
        Cart.add(variantId).finally(function() { btn.disabled = false; });
      });
    });

    initCartDrawerEvents();
  }

  /* =============================================
     QUICK VIEW
     ============================================= */
  function initQuickView() {
    const overlay = $('[data-quick-view-overlay]');
    const modal = $('[data-quick-view]');
    const content = $('[data-quick-view-content]');

    if (!modal) return;

    function openQuickView(handle) {
      modal.classList.add('is-open');
      overlay.classList.add('is-open');
      bodyLock();

      content.innerHTML = '<div class="quick-view__loading"><div class="spinner"></div><p>Cargando...</p></div>';

      fetch(`/products/${handle}?sections=product-template`)
        .then(res => res.json())
        .then(data => {
          const html = data['product-template'];
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const productSection = doc.querySelector('.product-template');
          if (productSection) {
            content.innerHTML = productSection.outerHTML;
            initProductPage(content);
          }
        })
        .catch(() => {
          content.innerHTML = '<p style="padding:2rem;text-align:center;">Error al cargar el producto</p>';
        });
    }

    function closeQuickView() {
      modal.classList.remove('is-open');
      overlay.classList.remove('is-open');
      bodyUnlock();
    }

    $$('[data-quick-view-trigger]').forEach(btn => {
      on(btn, 'click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openQuickView(btn.dataset.productHandle);
      });
    });

    on($('[data-quick-view-close]'), 'click', closeQuickView);
    on(overlay, 'click', closeQuickView);
  }

  /* =============================================
     PRODUCT PAGE
     ============================================= */
  function initProductPage(scope = document) {
    const container = $('[data-product-template]', scope) || scope;
    const productJSON = $('[data-product-json]', container);
    if (!productJSON) return;

    let product;
    try { product = JSON.parse(productJSON.textContent); } catch(e) { return; }

    const form = $('[data-product-form]', container);
    const variantSelect = $('[data-variant-select]', container);
    const addBtn = $('[data-add-to-cart]', container);
    const optionInputs = $$('[data-option-input]', container);

    // Gallery
    const gallerySlides = $$('[data-gallery-slide]', container);
    const galleryThumbs = $$('[data-gallery-thumb]', container);

    galleryThumbs.forEach(thumb => {
      on(thumb, 'click', () => {
        const idx = thumb.dataset.galleryThumb;
        gallerySlides.forEach(s => s.classList.remove('is-active'));
        galleryThumbs.forEach(t => t.classList.remove('is-active'));
        const targetSlide = $(`[data-gallery-slide="${idx}"]`, container);
        if (targetSlide) targetSlide.classList.add('is-active');
        thumb.classList.add('is-active');
      });
    });

    // Variant selection
    function updateVariant() {
      const selectedOptions = [];
      const optionGroups = $$('[data-option-index]', container);
      optionGroups.forEach(group => {
        const checked = $('[data-option-input]:checked', group);
        if (checked) selectedOptions.push(checked.value);
      });

      const variant = product.variants.find(v => {
        return v.options.every((opt, i) => opt === selectedOptions[i]);
      });

      if (variant) {
        if (variantSelect) variantSelect.value = variant.id;

        const priceEl = $('[data-product-price]', container);
        if (priceEl) {
          let priceHTML = '';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceHTML += `<span class="product-template__price-compare">${formatMoney(variant.compare_at_price)}</span>`;
            priceHTML += `<span class="product-template__price-current is-sale">${formatMoney(variant.price)}</span>`;
            const savings = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
            priceHTML += `<span class="product-template__price-savings">-${savings}%</span>`;
          } else {
            priceHTML += `<span class="product-template__price-current">${formatMoney(variant.price)}</span>`;
          }
          priceEl.innerHTML = priceHTML;
        }

        if (addBtn) {
          // Detectar si el producto tiene el tag "disponible"
          const productHasDisponibleTag = product.tags && product.tags.some(function(t){
            return t.toLowerCase() === 'disponible';
          });

          // Buscar el aviso amarillo de confección (puede o no existir)
          const preorderNotice = container.querySelector('.product-template__preorder-notice');

          // DISPONIBILIDAD POR TALLA (29-sep-2026): manda el stock real de la variante, no el tag del producto
          var stockEl = container.querySelector('[data-variant-stock]');
          var stockMap = {};
          try { stockMap = stockEl ? JSON.parse(stockEl.textContent) : {}; } catch (e) {}
          var qty = stockMap[String(variant.id)];
          var hasStock = (qty !== undefined) ? qty > 0 : (productHasDisponibleTag && variant.available);
          var availState = hasStock ? 'stock' : (variant.available ? 'preorder' : 'soldout');
          container.querySelectorAll('[data-avail-state]').forEach(function (el) { el.style.display = el.getAttribute('data-avail-state') === availState ? '' : 'none'; });
          container.querySelectorAll('[data-ship-state]').forEach(function (el) { el.style.display = el.getAttribute('data-ship-state') === availState ? '' : 'none'; });
          var qtyInput = container.querySelector('[data-quantity-input]');
          if (qtyInput) {
            if (availState === 'stock' && qty !== undefined && qty < 999) { qtyInput.max = qty; if (parseInt(qtyInput.value) > qty) qtyInput.value = qty; }
            else { qtyInput.removeAttribute('max'); }
          }

          // CASO 1: variante con stock → venta inmediata
          if (hasStock) {
            addBtn.disabled = false;
            addBtn.textContent = 'AGREGAR AL CARRITO';
            addBtn.classList.remove('btn--accent');
            addBtn.classList.add('btn--primary');
            addBtn.style.opacity = '';
            addBtn.style.cursor = '';
            if (preorderNotice) preorderNotice.style.display = 'none';
          }
          // CASO AGOTADO: variante NO disponible → solo ocurre en ediciones sin reposición (deny). NUNCA confección.
          else if (!variant.available) {
            addBtn.disabled = true;
            addBtn.textContent = 'AGOTADO';
            addBtn.classList.remove('btn--primary');
            addBtn.classList.add('btn--accent');
            addBtn.style.opacity = '0.5';
            addBtn.style.cursor = 'not-allowed';
            if (preorderNotice) preorderNotice.style.display = 'none';
          }
          // CASO CONFECCIÓN: made-to-order disponible (variante 'continue')
          else {
            addBtn.disabled = false;
            addBtn.textContent = 'PEDIR AHORA — PASA A CONFECCIÓN';
            addBtn.classList.remove('btn--primary');
            addBtn.classList.add('btn--accent');
            addBtn.style.opacity = '';
            addBtn.style.cursor = '';
            if (preorderNotice) {
              preorderNotice.style.display = 'flex';
            } else {
              // Crear el aviso dinámicamente si no existe
              const actionsDiv = addBtn.parentElement;
              const noticeDiv = document.createElement('div');
              noticeDiv.className = 'product-template__preorder-notice';
              noticeDiv.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg><span>Tu pedido entra a confección de inmediato. Entrega en <strong>8 a 10 días hábiles</strong>. Te notificaremos cuando se envíe.</span>';
              actionsDiv.appendChild(noticeDiv);
            }
          }
        }

        $$('[data-option-selected]', container).forEach((label, i) => {
          if (selectedOptions[i]) label.textContent = selectedOptions[i];
        });

        if (history.replaceState && !scope.closest?.('[data-quick-view]')) {
          const url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
      }
    }

    optionInputs.forEach(input => {
      on(input, 'change', updateVariant);
    });

    $$('[data-quantity-minus]', container).forEach(btn => {
      on(btn, 'click', () => {
        const input = btn.parentElement.querySelector('[data-quantity-input]');
        if (input) input.value = Math.max(1, parseInt(input.value) - 1);
      });
    });

    $$('[data-quantity-plus]', container).forEach(btn => {
      on(btn, 'click', () => {
        const input = btn.parentElement.querySelector('[data-quantity-input]');
        if (input) {
          var max = parseInt(input.getAttribute('max'));
          var current = parseInt(input.value);
          if (max && current >= max) return;
          input.value = current + 1;
        }
      });
    });

    // Add to cart via AJAX
    if (form) {
      on(form, 'submit', async (e) => {
        e.preventDefault();
        const originalText = addBtn ? addBtn.textContent.trim() : '';
        const isPreorder = originalText.includes('CONFECCIÓN') || originalText.includes('PEDIR');

        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = isPreorder ? 'PROCESANDO...' : 'AGREGANDO...';
        }

        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;

        // 24-oct-2026: propiedades de línea del formulario (ej. properties[Regalo])
        const properties = {};
        let hasProperties = false;
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value !== '') { properties[match[1]] = value; hasProperties = true; }
        }

        try {
          await Cart.add(variantId, quantity, hasProperties ? properties : undefined);
          if (addBtn) {
            addBtn.textContent = isPreorder ? '✓ PEDIDO RECIBIDO' : '✓ AGREGADO';
            setTimeout(() => {
              addBtn.disabled = false;
              addBtn.textContent = originalText;
            }, 2000);
          }
        } catch(err) {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = originalText;
          }
        }
      });
    }
  }

  /* =============================================
     SEARCH OVERLAY
     ============================================= */
  function initSearch() {
    const overlay = $('[data-search-overlay]');
    if (!overlay) return;

    $$('[data-search-toggle]').forEach(btn => {
      on(btn, 'click', () => {
        overlay.classList.toggle('is-open');
        if (overlay.classList.contains('is-open')) {
          const input = $('input', overlay);
          if (input) setTimeout(() => input.focus(), 300);
        }
      });
    });
  }

  /* =============================================
     MOBILE MENU
     ============================================= */
  function initMobileMenu() {
    const menu = $('[data-mobile-menu]');
    if (!menu) return;

    $$('[data-mobile-menu-toggle]').forEach(btn => {
      on(btn, 'click', () => {
        const isOpen = menu.classList.contains('is-open');
        menu.classList.toggle('is-open');
        if (!isOpen) bodyLock();
        else bodyUnlock();
      });
    });
  }

  /* =============================================
     COLLECTION FILTERS
     ============================================= */
  function initCollectionFilters() {
    const filtersSidebar = $('[data-filters]');
    if (!filtersSidebar) return;

    $$('[data-filters-toggle]').forEach(btn => {
      on(btn, 'click', () => {
        filtersSidebar.classList.toggle('is-open');
        if (filtersSidebar.classList.contains('is-open')) bodyLock();
        else bodyUnlock();
      });
    });

    on($('[data-filters-close]'), 'click', () => {
      filtersSidebar.classList.remove('is-open');
      bodyUnlock();
    });

    $$('[data-filter-toggle]').forEach(btn => {
      on(btn, 'click', () => {
        const content = btn.nextElementSibling;
        if (content) {
          content.style.display = content.style.display === 'none' ? '' : 'none';
          btn.querySelector('svg').style.transform = content.style.display === 'none' ? '' : 'rotate(180deg)';
        }
      });
    });

    const filterForm = $('[data-filter-form]');
    if (filterForm) {
      on(filterForm, 'change', () => {
        const params = new URLSearchParams();
        $$('input[type="checkbox"]:checked', filterForm).forEach(input => {
          params.append(input.name, input.value);
        });
        $$('input[type="number"]', filterForm).forEach(input => {
          if (input.value) params.append(input.name, input.value);
        });
        const url = `${window.location.pathname}?${params.toString()}`;
        window.location.href = url;
      });
    }

    const sortSelect = $('[data-sort-select]');
    if (sortSelect) {
      on(sortSelect, 'change', () => {
        const url = new URL(window.location);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }
  }

  /* =============================================
     PRODUCT SLIDER
     ============================================= */
  function initProductSliders() {
    $$('[data-product-slider]').forEach(slider => {
      const track = $('.product-slider__track', slider);
      if (!track) return;

      const slideWidth = () => {
        const slide = $('.product-slider__slide', track);
        return slide ? slide.offsetWidth + 24 : 300;
      };

      on($('[data-slider-prev]', slider), 'click', () => {
        track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
      });

      on($('[data-slider-next]', slider), 'click', () => {
        track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
      });
    });
  }

  /* =============================================
     TERMS & CONDITIONS CHECKBOX
     ============================================= */
  function initTermsCheckbox() {
    var checkbox = document.querySelector('[data-terms-checkbox]');
    var checkoutBtn = document.querySelector('[data-checkout-btn]');
    var errorMsg = document.querySelector('[data-terms-error]');

    if (checkbox && checkoutBtn) {
      function updateCheckout() {
        if (checkbox.checked) {
          checkoutBtn.classList.remove('cart-summary__checkout--disabled');
          checkoutBtn.classList.add('cart-summary__checkout--enabled');
          checkoutBtn.onclick = null;
          checkoutBtn.href = '/checkout';
          if (errorMsg) errorMsg.classList.remove('is-visible');
        } else {
          checkoutBtn.classList.add('cart-summary__checkout--disabled');
          checkoutBtn.classList.remove('cart-summary__checkout--enabled');
          checkoutBtn.onclick = function(e) {
            e.preventDefault();
            if (errorMsg) errorMsg.classList.add('is-visible');
            return false;
          };
        }
      }
      checkbox.addEventListener('change', updateCheckout);
      updateCheckout();
    }

    var checkboxDrawer = document.querySelector('[data-terms-checkbox-drawer]');
    var checkoutBtnDrawer = document.querySelector('[data-checkout-btn-drawer]');
    var errorMsgDrawer = document.querySelector('[data-terms-error-drawer]');

    if (checkboxDrawer && checkoutBtnDrawer) {
      function updateCheckoutDrawer() {
        if (checkboxDrawer.checked) {
          checkoutBtnDrawer.classList.remove('cart-summary__checkout--disabled');
          checkoutBtnDrawer.classList.add('cart-summary__checkout--enabled');
          checkoutBtnDrawer.onclick = null;
          checkoutBtnDrawer.href = '/checkout';
          if (errorMsgDrawer) errorMsgDrawer.classList.remove('is-visible');
        } else {
          checkoutBtnDrawer.classList.add('cart-summary__checkout--disabled');
          checkoutBtnDrawer.classList.remove('cart-summary__checkout--enabled');
          checkoutBtnDrawer.onclick = function(e) {
            e.preventDefault();
            if (errorMsgDrawer) errorMsgDrawer.classList.add('is-visible');
            return false;
          };
        }
      }
      checkboxDrawer.addEventListener('change', updateCheckoutDrawer);
      updateCheckoutDrawer();
    }
  }

  /* =============================================
     CART PAGE
     ============================================= */
  function initCartPage() {
    $$('[data-cart-quantity-minus]').forEach(btn => {
      on(btn, 'click', () => {
        const key = btn.dataset.cartQuantityMinus;
        const input = btn.parentElement.querySelector('[data-cart-quantity-input]');
        const qty = Math.max(0, parseInt(input.value) - 1);
        Cart.change(key, qty).then(() => location.reload());
      });
    });

    $$('[data-cart-quantity-plus]').forEach(btn => {
      on(btn, 'click', () => {
        const key = btn.dataset.cartQuantityPlus;
        const input = btn.parentElement.querySelector('[data-cart-quantity-input]');
        const qty = parseInt(input.value) + 1;
        Cart.change(key, qty).then(() => location.reload());
      });
    });

    $$('[data-cart-remove]').forEach(btn => {
      on(btn, 'click', () => {
        Cart.change(btn.dataset.cartRemove, 0).then(() => location.reload());
      });
    });
  }

  /* =============================================
     PRODUCT RECOMMENDATIONS
     ============================================= */
  function initProductRecommendations() {
    const section = $('[data-section-id] .product-recommendations');
    if (!section) return;

    const productId = $('[data-product-id]')?.value;
    if (!productId) return;

    const url = `/recommendations/products.json?product_id=${productId}&limit=4`;
    fetch(url)
      .then(res => res.json())
      .then(data => {})
      .catch(() => {});
  }

  /* =============================================
     KEYBOARD & ACCESSIBILITY
     ============================================= */
  function initAccessibility() {
    on(document, 'keydown', (e) => {
      if (e.key === 'Escape') {
        Cart.closeDrawer();

        const qvOverlay = $('[data-quick-view-overlay]');
        const qvModal = $('[data-quick-view]');
        if (qvModal?.classList.contains('is-open')) {
          qvModal.classList.remove('is-open');
          qvOverlay?.classList.remove('is-open');
          bodyUnlock();
        }

        const searchOverlay = $('[data-search-overlay]');
        searchOverlay?.classList.remove('is-open');

        const mobileMenu = $('[data-mobile-menu]');
        if (mobileMenu?.classList.contains('is-open')) {
          mobileMenu.classList.remove('is-open');
          bodyUnlock();
        }
      }
    });
  }

  /* =============================================
     INIT ALL
     ============================================= */
  function init() {
    initCartDrawer();
    initQuickView();
    initProductPage();
    initSearch();
    initMobileMenu();
    initCollectionFilters();
    initProductSliders();
    initCartPage();
    initTermsCheckbox();
    initProductRecommendations();
    initAccessibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
